import { i18n } from '@wms/shared';
import { ApiError } from './api.js';

const { t } = i18n;

interface StockShortage {
  skuId: string;
  required: number;
  onHand: number;
}

function stockShortages(body: unknown): StockShortage[] {
  if (!body || typeof body !== 'object') return [];
  const shortages = (body as { shortages?: unknown }).shortages;
  if (!Array.isArray(shortages)) return [];
  return shortages.filter(
    (row): row is StockShortage =>
      !!row &&
      typeof row === 'object' &&
      typeof (row as StockShortage).skuId === 'string' &&
      typeof (row as StockShortage).required === 'number' &&
      typeof (row as StockShortage).onHand === 'number',
  );
}

export function orderTransitionErrorMessage(
  error: unknown,
  skuLabels: ReadonlyMap<string, string>,
): string {
  if (
    !(error instanceof ApiError) ||
    !['insufficient_stock_for_assembly', 'insufficient_stock_for_delivery'].includes(error.code)
  ) {
    return t('common.error');
  }

  const shortages = stockShortages(error.body);
  if (shortages.length === 0) return t('order.transition.insufficient_stock');

  const details = shortages.map((shortage) => {
    const sku = skuLabels.get(shortage.skuId) ?? shortage.skuId;
    return `${sku}: ${t('order.transition.required')} ${shortage.required}, ${t('order.transition.on_hand')} ${shortage.onHand}`;
  });
  return [
    t('order.transition.insufficient_stock'),
    ...details,
    t('order.transition.insufficient_stock_action'),
  ].join('\n');
}
